export const GENRES = [
    'music',
    'culture',
    'family',
    'spectacles',
    'sports',
] as const;
